import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearModelsActions, getModelsActions } from '../../redux/actions/modelsActions';

const useFetchModels = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const brandId = useSelector((state) => state.models.brand?.id);
  const search = useSelector((state) => state.models?.search);
  const models = useSelector((state) => state.models?.models);
  const loading = useSelector((state) => state.models?.loading);

  const fetchModels = useCallback(async () => {
    if (brandId) {
      await dispatch(getModelsActions(search, brandId, unpaged));
    }
  }, [brandId, search, unpaged, dispatch]);

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  useEffect(() => {
    return () => {
      dispatch(clearModelsActions());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchModels();
  };

  return { loading, models, brandId, refresh };
};

export default useFetchModels;
